import dayjs from "dayjs";

export const coColumns=[
    {
        field: "lineNo",
        headerName: "Line No",
        align: "right",
      },
      {
        field: "returnCode",
        headerName: "Return Code",
        align: "left",
        left:180,
        width:150,
      },
      {
        field: "skuCode",
        headerName: "SKU Code",
        align: "left",
        left:330,
        width:200
      },
      {
        field: "packType",
        headerName: "Pack Type",
        width: 100,
        align: "left",
      },
      {
        field: "coQty",
        headerName: "CO Qty",
        width: 80,
        align: "right",
      },
      {
        field: "qtyReceived",
        headerName: "Qty Received",
        width: 120,
        align: "right",
      },
      {
        field: "baseUOM",
        headerName: "Base UOM",
        width: 100,
        align: "left",
      },
      {
        field: "mln",
        headerName: "MLN",
        width: 120,
        align: "left",
      },
      {
        field: "custOrdNbr",
        headerName: "Order No",
        width: 220,
        align: "left",
      },
      {
        field: "doNumber",
        headerName: "DO No",
        width: 220,
        align: "left",
      },
      {
        field: "expiryDate",
        headerName: "Expiry Date",
        width: 120,
        align: "left",
        valuesGetter: (col) => {
          return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
        },
      }
]